// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3TCHI5","imageWrapper":"_1H1rwo"};